import BoBForecast from "./BoBForecast";

export default BoBForecast;